import { render, staticRenderFns } from "./CandidateRegistration.vue?vue&type=template&id=5d297f7b"
import script from "./CandidateRegistration.vue?vue&type=script&lang=js"
export * from "./CandidateRegistration.vue?vue&type=script&lang=js"
import style0 from "./CandidateRegistration.vue?vue&type=style&index=0&id=5d297f7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports